let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("92KXm")).then(() => parcelRequire('briIo'));